import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { getProject } from '../../projects'
import {
  ProjectLayout,
  ProjectIntro,
  Title,
  Paragraph,
} from '../../layouts/project'

import { useNavbarTheme } from '../../contexts/NavbarTheme'

import { media } from '../../styles/tools'

import { AutoFade, AutoSlide } from '../../components/Animated'
import Wrapper from '../../components/Wrapper'
import Space from '../../components/Space'
import VideoPlayer from '../../components/VideoPlayer'

import Logo from '../../assets/pages/work/press-pops/Logo.js'

export const query = graphql`
  {
    headerImage: file(relativePath: { eq: "pages/work/press-pops.jpg" }) {
      ...windowWide
    }
    facebookImage: file(relativePath: { eq: "pages/work/press-pops.jpg" }) {
      ...facebookShareImage
    }
    twitterImage: file(relativePath: { eq: "pages/work/press-pops.jpg" }) {
      ...twitterShareImage
    }
  }
`

let project = getProject('press-pops')

export default ({ data }) => {
  project = {
    ...project,
    headerImage: data.headerImage.childImageSharp.fluid,
    facebookImage: data.facebookImage.childImageSharp.fixed.src,
    twitterImage: data.twitterImage.childImageSharp.fixed.src,
    logo: <Logo />,
  }

  useNavbarTheme('dark')

  return (
    <ProjectLayout project={project}>
      <ProjectIntro
        project={project}
        text={
          <Fragment>
            <AutoFade>
              <Title as="h1" css={{ maxWidth: '11em' }}>
                True to our roots.
              </Title>
            </AutoFade>
            <Space y={32} />
            <AutoFade>
              <Paragraph>
                Press Brothers Juicery, a Los Angeles-based brand famous for
                their unique blend of cold-pressed juices tapped us to help them
                launch their very own brand of frozen popsicles, made with, you
                guessed it certified organic, cold-pressed, juice. A big part of
                Press Pop’s uniqueness is their process; using raw,
                unpasteurized, organic fruits and vegetables devoid of
                preservatives or additives.
              </Paragraph>
            </AutoFade>
            <Space y={16} />
            <AutoFade>
              <Paragraph>
                We knew rational benefits were simply not enough to break from
                the crowd of a growing segment. Our goal was to create a brand
                with refined positioning - differentiated and aspirational.
              </Paragraph>
            </AutoFade>
          </Fragment>
        }
      >
        <Space y={{ mobile: 60, tablet: 100 }} />
        Intro
      </ProjectIntro>
      <Wrapper>
        <Space y="25vw" />
        <Space y={{ mobile: 80, tablet: 150 }} />
        Content
      </Wrapper>
    </ProjectLayout>
  )
}
